var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0v81.217l27.104-27.009 47.409 47.409 27.104-27.104-47.409-47.409L81.313 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M74.513 88.017L27.104 40.608 9.577 58.135V9.577h48.558L40.608 27.104l47.409 47.409z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDIiIGhlaWdodD0iMTAyIiB2aWV3Qm94PSIwIDAgMTAyIDEwMiI+PGcgZmlsbD0ibm9uZSI+PHBvbHlnb24gZmlsbD0iI0ZGRiIgcG9pbnRzPSIwIDAgMCA4MS4yMTcgMjcuMTA0IDU0LjIwOCA3NC41MTMgMTAxLjYxNyAxMDEuNjE3IDc0LjUxMyA1NC4yMDggMjcuMTA0IDgxLjMxMyAwIi8+PHBvbHlnb24gZmlsbD0iIzAwMCIgcG9pbnRzPSI3NC41MTMgODguMDE3IDI3LjEwNCA0MC42MDggOS41NzcgNTguMTM1IDkuNTc3IDkuNTc3IDU4LjEzNSA5LjU3NyA0MC42MDggMjcuMTA0IDg4LjAxNyA3NC41MTMiLz48L2c+PC9zdmc+";
export { SvgArrowBold as ReactComponent };